(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/order-home-router.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/order-home-router.js');
"use strict";

const _ReactRouterDOM = ReactRouterDOM,
  useRouteMatch = _ReactRouterDOM.useRouteMatch;
const Route = svs.app.ReactRouter.Route;
const _svs$ticketsOrderHome = svs.ticketsOrderHome.pages,
  Choose = _svs$ticketsOrderHome.Choose,
  Receiver = _svs$ticketsOrderHome.Receiver,
  Preview = _svs$ticketsOrderHome.Preview,
  PreviewCoverletter = _svs$ticketsOrderHome.PreviewCoverletter,
  Message = _svs$ticketsOrderHome.Message,
  Confirmation = _svs$ticketsOrderHome.Confirmation;
const OrderHomeProvider = svs.ticketsOrderHome.context.OrderHomeProvider;
const LoginRequiredRoute = svs.ticketsOrderHome.components.LoginRequiredRoute;
const NavigationBack = svs.tur.NavigationBack;
const branding = svs.tickets.data.templateConfig.branding === 'triss' ? 'triss' : null;
const InstructionsInfo = svs.ticketsOrderHome.components.InstructionsInfo;
const DIVIDER = svs.ticketsOrderHome.routes.DIVIDER;
const _svs$ticketsOrderHome2 = svs.ticketsOrderHome.routes.ORDER_HOME,
  CHOOSE = _svs$ticketsOrderHome2.CHOOSE,
  RECEIVER = _svs$ticketsOrderHome2.RECEIVER,
  PREVIEW_COVERLETTER = _svs$ticketsOrderHome2.PREVIEW_COVERLETTER,
  PREVIEW = _svs$ticketsOrderHome2.PREVIEW,
  MESSAGE = _svs$ticketsOrderHome2.MESSAGE,
  CONFIRMATION = _svs$ticketsOrderHome2.CONFIRMATION;
const routes = history => ({
  [CHOOSE]: {
    text: 'Beställ hem/',
    navigate: () => history.push(DIVIDER)
  },
  [RECEIVER]: {
    text: 'Beställ hem/',
    navigate: () => history.push(CHOOSE)
  },
  [PREVIEW]: {
    text: 'Beställ hem/',
    navigate: () => history.push(CHOOSE)
  },
  [PREVIEW_COVERLETTER]: {
    text: 'Beställ hem/',
    navigate: () => history.push(MESSAGE)
  },
  [MESSAGE]: {
    text: 'Beställ hem/',
    navigate: () => history.push(RECEIVER)
  },
  [CONFIRMATION]: {
    text: 'Beställ hem/',
    navigate: () => history.push(CHOOSE)
  }
});
const breadcrum = 'Köp lotter';
const cancelUrl = "".concat(svs.core.data.baseUrl).concat(CHOOSE);
const Instructions = () => {
  const isOnDividerPage = useRouteMatch(DIVIDER);
  const isOnConfirmationPage = useRouteMatch(CONFIRMATION);
  if (isOnDividerPage !== null && isOnDividerPage !== void 0 && isOnDividerPage.isExact) {
    return null;
  }
  return React.createElement("div", {
    className: "bg-white need-help-min-height padding-h-1 ".concat(isOnConfirmationPage !== null && isOnConfirmationPage !== void 0 && isOnConfirmationPage.isExact ? 'padding-v-1' : 'padding-v-3')
  }, React.createElement(InstructionsInfo, {
    showStepByStep: !(isOnConfirmationPage !== null && isOnConfirmationPage !== void 0 && isOnConfirmationPage.isExact)
  }));
};
const OrderHomeRouter = () => {
  const _ReactRouterDOM2 = ReactRouterDOM,
    useHistory = _ReactRouterDOM2.useHistory;
  const history = useHistory();
  return React.createElement(OrderHomeProvider, null, React.createElement(React.Fragment, null, React.createElement(NavigationBack, {
    brand: branding,
    breadcrum: breadcrum,
    routes: routes(history)
  }), React.createElement(Route, {
    component: Choose,
    exact: true,
    path: CHOOSE
  }), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Preview,
    exact: true,
    path: PREVIEW
  }), React.createElement(React.Fragment, null, React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Receiver,
    exact: true,
    path: RECEIVER
  }), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Message,
    exact: true,
    path: MESSAGE
  }), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: PreviewCoverletter,
    exact: true,
    path: PREVIEW_COVERLETTER
  })), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Confirmation,
    exact: true,
    path: CONFIRMATION
  }), React.createElement(Instructions, null)));
};
setGlobal('svs.ticketsOrderHome.OrderHomeRouter', OrderHomeRouter);

 })(window);